import React, { useState } from "react";
import Header from "../Header/Header";
import StatsCards from "./StatsCards";
import TravelAnalysis from "./TravelAnalysis";
import CustomTitle from "../Custom/CustomTitle";

import dashBoardService from "../Services/dashBoardService";
import useScrollToTop from "../../components/hooks/useScrollToTop";

const DashboardPage = () => {

    const [travelData, setTravelData] = useState(null)




    
    useScrollToTop()
  return (
    <div className="min-h-screen bg-appGrayBackground">
      <Header />

      <div className="px-6 pt-28 pb-10">
        <div className="flex justify-between items-center mb-8">
            <div className="flex items-center gap-4">
            <CustomTitle title={"Dashboard"}  textColor={"primary"}/>
            <div className="px-2 py-1 border text-xs text-blue-600 border-blue-600 bg-blue-100 rounded-full">
              Note: This card data auto-refreshes every 60 minutes
             
            </div>
            </div>
        </div>

        <StatsCards />
        <TravelAnalysis  apiData={travelData} 
      onEmployeeChange={(employee) => console.log('Employee changed:', employee)}
      onDateRangeChange={(dateRange) => console.log('Date range changed:', dateRange)}
  />
      </div>
    </div>
  );
};

export default DashboardPage;
